import { render, staticRenderFns } from "./_income.vue?vue&type=template&id=1977907c"
import script from "./_income.vue?vue&type=script&lang=js"
export * from "./_income.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports